import UserData from "./UserData";
import AppUtils from "../control/apputlis";
import Apis from "../network/Apis";
import MatchType from "./MatchType";
import DeviceEventEmitter, { EventName } from "../control/event";
import AppConfig from "../control/config";
import DateUtils from "../control/dateutils";
import FIMUtils from "../im/FIMUtils";
import IMApp from "../net/IMApp";

export default class AppData {
    static me = new UserData();
    static InviteCode = '';
    static FastKey = '';
    static schedusMatchData = [];
    static schedusTypeData = [];
    static starMatchData = [];
    static starAnchorData = null;
    static starLeagueData = null;
    static shareConfigData = null;
    static recommAnchorData = [];
    static TypeHostRecomm = [];
    static MsgShield = []; // 关键字
    static ServerConfig = null;
    static Location = ['北京'];
    static IsCloseChat = false;
    static serverID = 0;
    static isMatch = '';
    static isYk = false;

    static isLoadingStarAnchor = false;
    static isLoadingStarLeague = false;
    static isLoadingStarMatch = [false, false, false];

    static ShareUrl = '';
    static ShareIcon = '';
    static ShareTittle = '';
    static ShareContent = '';
    static lastReqUpdateTime = 0;
    static os = '';
    static fistOpen = true;
    static homeTabIndex = 0;



    static setSchedusTypeData(data) {
        AppData.schedusTypeData = data;
    }

    static getSchedusTypeData() {
        return AppData.schedusTypeData ? AppData.schedusTypeData : [];
    }

    static setSchedusMatchData(type_id, data) {
        AppData.schedusMatchData[type_id] = data;
    }

    static getSchedusMatchData(type_id) {
        return AppData.schedusMatchData[type_id] ? AppData.schedusMatchData[type_id] : [];
    }


    static paserLogin(result) {
        var user = result;
        AppData.me.Uid = user.id;
        AppData.me.Username = user.username;
        AppData.me.PhoneNum = result.phone;
        AppData.me.PcToken = user.pc_token;
        AppData.me.Pic = user.portrait;
        AppData.me.RealStatus = user.real_status;//实名认证状态（1：已经认证，2：没有认证）
        AppData.me.free_id = user.free_fid;
        AppData.me.score = user.score
        AppData.me.chat_id = user.free_id;
    }

    static logout(needLoginTourist = true) {
        AppData.me.Uid = 0;
        AppData.me.Username = "";
        AppData.me.PhoneNum = "";
        AppData.me.PcToken = "";
        AppData.me.Pic = "";
        AppData.me.RealStatus = 2;//实名认证状态（1：已经认证，2：没有认证）
        AppData.me.token = '';
        AppData.me.customer_id = 0;
        AppData.me.userSign = '';
        AppUtils.setStorageItem("user_token", '');
        AppUtils.setStorageItem("user_customer_id", '');

        AppUtils.setStorageItem("phone_num", '');
        AppUtils.setStorageItem("fastkey", '0');
        AppUtils.setStorageItem("uid", '0');
        // localStorage.setItem("roomIp", '');
        // localStorage.setItem("roomPort", '');

        IMApp.user.uid = '';

        AppData.schedusMatchData = [];
        AppData.schedusTypeData = [];
        AppData.starMatchData = [];
        AppData.starAnchorData = null;
        AppData.starLeagueData = null;
        AppData.shareConfigData = null;
        AppData.imoutsocket();
       
    }

    //退出登录后，重新游客登录
    static imoutsocket(){
        FIMUtils.logout(function () {
            AppData.ykLogin()
        });
    }

    static imLoginout(needLoginTourist) {
        FIMUtils.logout(function () {
            if (needLoginTourist) {
                AppData.encryptionTourists();
            }
        });
    }

    static loginIn() {
        AppData.me.userSign = '';
        FIMUtils.logout(function () {
            AppData.getUserInfo();
        });
    }

    // static login(phone, fastkey, uid, customer_id, token) {

    //     if (phone && phone.length > 0 && fastkey && fastkey.length > 0) {
    //         IMApp.setAppWeb(true);
    //         AppData.encryptionCustomerLoginFree(phone, fastkey, uid, customer_id, token);
    //     } else {
    //         let token = AppUtils.getStorageItem("user_token");
    //         let customer_id = AppUtils.getStorageItem("user_customer_id");
    //         let phone_num = AppUtils.getStorageItem('phone_num');
    //         if (token && token.length > 0 && customer_id && customer_id > 0 && token != 'null' && customer_id != 'null') {
    //             AppData.me.token = token;
    //             AppData.me.customer_id = customer_id;
    //             AppData.me.PhoneNum = phone_num;
    //             AppData.getUserInfo();  
    //             AppData.reqHeatBeat();
    //             AppData.getMsgShield();
    //             AppData.getServerConfig(); 
    //         } else {
    //             if (!AppData.me.userSign || AppData.me.userSign == '') {
    //                 //游客登录
    //                 AppData.encryptionTourists(); 
    //             }
    //             DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
    //         }
    //     }

    // }

    //快捷登录
    static login = async () => {

        //先拿到手机号和fastkey
        let phone = AppUtils.getStorageItem("phone_num");
        let fastkey = AppUtils.getStorageItem("fastkey");

       

        if (fastkey && fastkey.length > 0 && fastkey != null && phone && phone != '') {
            AppData.userLogin(phone,fastkey)
        } else {
            AppData.ykLogin()
        }
    }

    static userLogin = async(phone,fastkey)=>{
        if (IMApp.user.uid == undefined || IMApp.user.uid == "") {
            let uid = AppUtils.getStorageItem('uid')
            if (uid == "" || uid == null ||uid == undefined || uid == "0") {
                return;
            }
            IMApp.user.uid = uid;
        }
        console.log("fastLogin",IMApp.user.uid);

        //用户登录
        let Imresult = await FIMUtils.fastLogin(phone, fastkey);  
       
        
        if (Imresult.ret !== 0) {
            //没登录成功
            AppUtils.setStorageItem('fastkey', "")
            AppData.ykLogin()
            return;
        }
        AppUtils.setStorageItem('uid', Imresult.user.uid)
        AppUtils.setStorageItem('roomIp', Imresult.server[0].svrip)
        AppUtils.setStorageItem('roomPort', Imresult.server[0].websvrport) 

        IMApp.user.uid = Imresult.user.uid;
        AppData.me.free_id = Imresult.user.fid
        AppData.me.isYk = false;

        let result = await Apis.encryptionCustomerLogin(phone, Imresult.fastkey, Imresult.user.uid);

        if (result.code == 200) {
            AppData.me.token = result.data.token;
            AppData.me.customer_id = result.data.customer_id;
            AppData.me.PhoneNum = phone;
            localStorage.setItem("phone_num", AppData.me.PhoneNum);
            localStorage.setItem("user_token", AppData.me.token);
            localStorage.setItem("user_customer_id", AppData.me.customer_id);
            AppData.getUserInfo();
            AppData.reqHeatBeat();
            AppData.getMsgShield();
            AppData.getServerConfig();
            FIMUtils.connectWebSocket(Imresult);
            console.log("用户登录完成");
            
            DeviceEventEmitter.emit('LoginSuccess');
            AppUtils.YMPush('MAIN', '登录成功');
        }
    }

    static ykLogin = async()=>{
        //游客登录
        let Imresult = await FIMUtils.ykLogin();
        if (Imresult.ret !== 0) {
            //没登录成功
            return;
        }


        AppData.me.Pic = Imresult.user.headurl
        // AppData.me.free_id
        AppUtils.setStorageItem('uid', Imresult.user.uid)
        AppUtils.setStorageItem('fastkey', Imresult.fastkey)

        AppData.me.free_id = Imresult.user.fid 

        AppUtils.setStorageItem('roomIp', Imresult.server[0].svrip)
        AppUtils.setStorageItem('roomPort', Imresult.server[0].websvrport)

        IMApp.user.uid = Imresult.user.uid;
        AppData.me.isYk = true;

        FIMUtils.connectWebSocket(Imresult);
        AppUtils.YMPush('MAIN', '登录成功');
        AppData.encryptionTourists(Imresult.user.uid);
    }

    

    static isStarMatch(type_id, matchId) {
        if (AppData.starMatchData && AppData.starMatchData[type_id]) {
            let data = AppData.starMatchData[type_id];
            for (let i = 0; i < data.length; i++) {
                if (data[i].id == matchId) {
                    return true;
                }
            }
        }
        return false;
    }

    static isStarAnchor(anchor) {
        if (AppData.starAnchorData && AppData.starAnchorData.length > 0) {
            for (let i = 0; i < AppData.starAnchorData.length; i++) {
                const element = AppData.starAnchorData[i];
                if (anchor == element.user_id) {
                    return true;
                }
            }
        }
        return false;
    }

    static starAnchor() {
        if (AppData.isLoadingStarAnchor) {
            return;
        }
        if (!AppData.me.isLogin()) {
            return;
        }
        AppData.isLoadingStarAnchor = true;
        AppData.getStarAnchor();
    }

    static starLeague() {
        if (AppData.isLoadingStarLeague) {
            return;
        }
        if (!AppData.me.isLogin()) {
            return;
        }
        AppData.isLoadingStarLeague = true;
        AppData.getStarLeague();
    }

    static starMatch(type_id) {
        if (AppData.isLoadingStarMatch[type_id]) {
            return;
        }
        if (!AppData.me.isLogin()) {
            return;
        }
        AppData.isLoadingStarMatch[type_id] = true;
        AppData.getStarMatch(type_id);
    }

    static getStarAnchor = async () => {
        let result = await Apis.encryptionShowFocusHost();
        // console.log('getStarAnchor', result);
        if (result.code == 200) {
            AppData.starAnchorData = result.data;
            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        }
    }

    static getStarLeague = async () => {
        let result = await Apis.encryptionShowFocusLeague();
        // console.log('getStarLeague', result);
        if (result.code == 200) {
            let data = result.data.sort((a, b) => {
                return b.count - a.count;
            })
            AppData.starLeagueData = data;
            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        }
    }

    static getStarMatch = async (type_id) => {
        let result = await Apis.encryptionShowFocusEvent(type_id);
        // console.log('getStarMatch', result);
        if (result.code == 200) {
            AppData.starMatchData[type_id] = result.data;
            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        }
    }

    static encryptionTourists = async (uid) => {
        let result = await Apis.encryptionTourists(AppConfig.deviceid, window.location.href, uid);
        console.log('encryptionTourists', result);
        if (result.code == 200) {
            // let user = result.data.free_data.user
            // AppData.me.Username = user.nickname;
            // AppData.me.Pic = user.headurl;


            AppData.me.Uid = result.data.id;
            AppData.me.identifier = result.data.identifier;
            AppData.me.userSign = result.data.userSig;
            AppData.me.free_id = result.data.free_data.user.fid;

            AppData.me.customer_id = result.data.customer_id;

            FIMUtils.init();
            FIMUtils.login('', AppData.me.Uid);
            AppData.reqHeatBeat();
            AppData.getMsgShield();
            AppData.getServerConfig();

            console.log("游客登录完成");

            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
            DeviceEventEmitter.emit('LoginSuccess');
        }
    }

    static encryptionCustomerLoginFree = async (phone, fastKey, uid, customer_id, token) => {
        // let result = await Apis.encryptionCustomerLoginFree(phone, fastKey, uid);
        console.log('encryptionCustomerLoginFree', fastKey);
        AppData.me.token = token;
        AppData.me.customer_id = customer_id;
        AppData.me.free_id = uid;
        AppData.me.fastkey = fastKey;
        FIMUtils.init();
        FIMUtils.login(phone, fastKey);
        AppData.reqHeatBeat();
        AppData.getMsgShield();
        AppData.getServerConfig();
        DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        
    }



    static getUserInfo = async () => {
        let result = await Apis.encryptionShowCustomer();
        console.log('getUserInfo',result);
        if (result.code == 200) {
            AppData.paserLogin(result.data);
            AppData.sync();
            // AppData.getUserSig();
            AppData.getVipLevel();
        } else {
            DeviceEventEmitter.emit(EventName.EVENT_UPDATE_USERINFO);
        }
    }


    //获取等级
    static getVipLevel = async () => {
        let customer_id = AppData.me.customer_id;
        let token = AppData.me.token;
        let channel = AppConfig.channelid;
        let result = await Apis.getVipData(customer_id, token, channel);
        if (result.code == 200) {
            let data = result.data;
            AppData.me.level = data.level
            // console.log("获取到vip等级====》", data.level);
        }
    }



    static getUserSig = async () => {
        if (AppData.me.userSign != '' && AppData.me.identifier != '') {
            FIMUtils.init();
            FIMUtils.login(AppData.me.PhoneNum, AppData.me.Uid);
        } else {
            let result = await Apis.encryptionSign(AppData.me.Uid);
            console.log('getUserSig', result);
            if (result.code == 200) {
                AppData.me.identifier = AppData.me.Uid;
                AppData.me.userSign = result.data;
                FIMUtils.init();
                FIMUtils.login(AppData.me.PhoneNum, AppData.me.Uid);
            }
        }
    }

    static sync() {
        AppData.starMatch(MatchType.FOOTBALL)
        AppData.starMatch(MatchType.BASKETBALL)
        AppData.starAnchor();
        AppData.starLeague();
        AppData.getShareConfig();
    }

    static checkUpdate = async () => {
        let now = DateUtils.getCurTime();
        if ((now - AppData.lastReqUpdateTime) > 60 * 1000) {
            let result = await Apis.encryptionVersion(AppConfig.version);
            // console.log('checkUpdate', result);
            if (result.code == 200 && result.data && result.data.version) {
                if (AppConfig.version < Number(result.data.version)) {
                    window.location.reload(true);
                }
            }
            AppData.lastReqUpdateTime = now;
        }
    }

    static heatBeat() {
        if (AppData.heatBeatInterval) {
            return;
        }
        AppData.heatBeatInterval = setInterval(() => {
            AppData.reqHeatBeat();
        }, 3 * 1000 * 60);
    }

    static async reqHeatBeat() {
        if (!AppData.me.identifier && !AppData.me.customer_id) {
            return;
        }
        let usertype = 1;
        if (AppData.me.isLogin()) {
            usertype = 2;
            let resx = await Apis.encryptionHeartLogCustomer(AppData.me.token, AppData.me.customer_id);
        }
        let userId = 1;
        if (AppData.me.customer_id > 0) {
            userId = AppData.me.customer_id;
        } else {
            if (AppData.me.identifier.startsWith('tourists_')) {
                userId = AppData.me.identifier.substring('tourists_'.length);
            }
        }
        let phone = AppData.me.PhoneNum;
        let phone_code = AppConfig.deviceid;


        let res = await Apis.encryptionHeartLog(usertype, userId, phone, phone_code);
        // console.log('heatBeat', res);
    }



    static async getMsgShield() {
        if (AppData.MsgShield && AppData.MsgShield.length > 0) {
            return;
        }
        let result = await Apis.encryptionMsgShield();
        // console.log('getMsgShield', result);
        if (result.code == 200) {
            AppData.MsgShield = result.data;
        }
    }

    static keywordShield(str) {
        if (str.length < 1) {
            return str;
        }

        //如果关键字还没获取到，也是直接返回
        if (AppData.MsgShield.length == 0) {
            return str;
        }


        //替换字符串
        String.prototype.replaceAll = function (s1, s2) {
            return this.replace(new RegExp(s1, "gm"), s2);
        }

        for (let i = 0; i < AppData.MsgShield.length; i++) {
            let star = '';
            let tmp = AppData.MsgShield[i];
            for (let j = 0; j < tmp.length; j++) {
                star += "*";
            }
            str = str.replaceAll(AppData.MsgShield[i], star);
        }
        return str;
    }


    static async getServerConfig() {
        if (AppData.ServerConfig) {
            return;
        }
        let res = await Apis.encryptionServerConfig();

        if (res.code == 200 && res.data) {
            AppData.ServerConfig = res.data;
        }
    }

    static isOutOfDate(time) {
        let curtime = DateUtils.getCurTime();
        let tmep = (time + AppData.ServerConfig.private_message_over * 24 * 60 * 60) * 1000;
        return curtime > tmep;
    }

    static getLocation() {
        console.log('getLocation', navigator.geolocation);
        var BMap = window.BMap;
        if (BMap) {
            var geoc = new BMap.Geocoder();
            var geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(function (r) {
                geoc.getLocation(r.point, function (rs) {
                    console.log(rs)
                    if (rs && rs.addressComponents && rs.addressComponents.city) {
                        var addComp = rs.addressComponents;
                        let cityName = addComp.city;
                        let exist = false;
                        for (let i = 0; i < AppData.Location.length; i++) {
                            if (cityName && cityName.indexOf(AppData.Location[i]) >= 0) {
                                exist = true;
                            }
                        }

                        if (exist) {
                            AppData.IsCloseChat = true;
                        }
                    }
                });
            });
        }
        else {
            console.log('getLocation', navigator.geolocation);
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    AppData.getCity(position);
                });
            }
        }
    }

    static async getCity(position) {
        let lat = position.coords.latitude;
        let lng = position.coords.longitude;
        let result = await Apis.encryptionGetCity(lat, lng);
        console.log('getCity', result);
        if (result && result.code == 200) {
            result = result.data;
            if (result && result.status == 'OK') {
                if (result.result && result.result.addressComponent && result.result.addressComponent.city) {
                    let city = result.result.addressComponent.city;
                    let exist = false;
                    for (let i = 0; i < AppData.Location.length; i++) {
                        if (city && city.indexOf(AppData.Location[i]) >= 0) {
                            exist = true;
                        }
                    }
                    if (exist) {
                        AppData.IsCloseChat = true;
                    }
                }
            }
        }
    }

    static getShareConfig = async () => {
        if (AppData.ShareUrl.length > 0) {
            return;
        }
        let result = await Apis.encryptionConfig();
        console.log('encryptionConfig',result); 
        if (result.code == 200) {
            AppData.ShareUrl = result.data.download_url;
            AppData.ShareIcon = result.data.share_icon;
            AppData.ShareTittle = result.data.share_title;
            AppData.ShareContent = result.data.share_text;
            AppData.app_68 = result.data.app_68;
        }
    }
}
